var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"font-size-smaller",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.wordCount)+" / "+_vm._s(_vm.maxWord))])
}
var staticRenderFns = []

export { render, staticRenderFns }